module.exports = __webpack_public_path__ + "settings_selected.fb74d4f75aaf8d8fbc8c6392d6ed45f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/settings_selected.svg
// module id = 1153
// module chunks = 0